import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map, shareReplay, take } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

@Injectable()
export class TranslationLoaderService implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<object> {
    const langMap = new Map<string, string>().set('km', 'khr').set('zh', 'cny');

    return this.http.get(`./assets/i18n/${langMap.get(lang) ?? lang}.json`).pipe(
      shareReplay(1),
      take(1),
      map((response: JSON) => response),
    );
  }
}
